import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";

const MillstageDropDownFilter = ({
  label,
  data = [],
  selectedValue,
  setSelectedValue,
  selectedId,
  setSelectedId,
  placeholder = "Select...",
  isdark,
  iscolour,
  iscolourDark,
  isMulti = true,
  disabled = false,
  onChange
}) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // const filteredData = data.filter((item) =>
  //   item.label.toLowerCase().includes(searchTerm.toLowerCase()),
  // );
  const filteredData = data.filter((item) =>
    (item?.label || "")
      .toLowerCase()
      .includes((searchTerm || "").toLowerCase()),
  );

  const dropdownRef = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <style>
        {`
.custom-scroll::-webkit-scrollbar {
  width: 5px;
}

.custom-scroll::-webkit-scrollbar-track {
  background: ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour3};
  border-radius: 20px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour7};
  border-radius: 20px;
  border: 1px solid transparent;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour7};
}

.custom-scroll::-webkit-scrollbar-corner {
  background: transparent;
}

 .search-input::placeholder {
                                    color: ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour9};
                                    opacity: 1;
                                    }
                                    .search-input:focus{
  border-color: ${isdark === "light"
            ? iscolour?.Colour1
            : iscolourDark?.Colour5} !important;

  box-shadow: 0 0 0 0.2rem ${isdark === "light"
            ? `${iscolour?.Colour6}40`
            : `${iscolourDark?.Colour1}40`
          } !important;

  outline: none !important;
`}
      </style>
      <div ref={dropdownRef} style={{ position: "relative" }}>
        {/* LABEL */}
        <div
          style={{
            color: isdark === "light" ? iscolour?.Colour1 : "#fff",
            fontWeight: "700",
            fontSize: "13px",
            marginBottom: "5px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "5px",
            }}
          >
            <span
              style={{
                color: isdark === "light" ? iscolour?.Colour9 : "#fff",
                fontWeight: "700",
                fontSize: "13px",
              }}
            >
              {label}
            </span>

            {/* +More badge */}
            {isMulti &&
              Array.isArray(selectedValue) &&
              selectedValue.length > 1 && (
                <span
                  title={selectedValue.join(", ")}
                  style={{
                    background:
                      isdark === "light"
                        ? iscolour?.Colour8
                        : iscolourDark?.Colour8,
                    color: "#fff",
                    padding: "2px 8px",
                    borderRadius: "10px",
                    fontSize: "11px",
                    fontWeight: "600",
                    whiteSpace: "nowrap",
                  }}
                >
                  +{selectedValue.length - 1} more
                </span>
              )}
          </div>
        </div>

        {/* HEADER */}
        <div
          onClick={() => !disabled && setOpen(!open)}
          style={{
            borderRadius: "12px",
            padding: " 12px 20px",
            background: disabled
              ? isdark === "light" ? "#e2e8f0" : "#334155"
              : isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour9,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: disabled ? "not-allowed" : "pointer",
            fontWeight: "500",
            color: disabled
              ? isdark === "light" ? "#94a3b8" : "#94a3b8"
              : isdark === "light" ? iscolour?.Coloured12 : "#fff",
            opacity: disabled ? 0.7 : 1,
          }}
        >
          <span>
            <span>
              {isMulti
                ? Array.isArray(selectedValue) && selectedValue.length > 0
                  ? selectedValue.length <= 1
                    ? selectedValue.join(", ")
                    : selectedValue.slice(0, 1).join(", ")
                  : placeholder
                : selectedValue || placeholder}
            </span>
          </span>

          <FaChevronDown
            style={{
              transition: "0.3s",
              transform: `rotate(${open ? 180 : 0}deg)`,
            }}
          />
        </div>

        {/* DROPDOWN */}

        {open && (
          <div
            style={{
              position: "absolute",
              top: "110%",
              left: 0,
              right: 0,
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour6,
              borderRadius: "12px",
              padding: "10px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              zIndex: 999,
              maxHeight: "300px",
              overflow: "hidden",
            }}
          >
            <input
              className="search-input"
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "10px",
                borderRadius: "8px",
                outline: "none",
                fontSize: "13px",
                border: `1px solid ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8}`,
                backgroundColor: isdark === "light" ? "#fff" : iscolourDark?.Colour5,
                color: isdark === "light" ? "#000" : "#fff",
              }}
            />

            {/* CLEAR BUTTON */}
            <div
              style={{
                width: "100%",
                marginBottom: "8px",
              }}
            >
              <button
                onClick={() => {
                  if (isMulti) {
                    setSelectedValue([]);
                    setSelectedId([]);
                  } else {
                    setSelectedValue("");
                    setSelectedId(null);
                  }
                }}
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: "10px",
                  padding: "10px",
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "0.25s",

                  background:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour9,

                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 10px rgba(0,0,0,0.15)";
                  e.currentTarget.style.background =
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour9;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.background =
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour9;
                }}
              >
                Clear All
              </button>
            </div>

            {/* LIST */}
            <div
              className="custom-scroll"
              style={{
                maxHeight: "170px",
                overflowY: "auto",
                overflowX: "hidden",
                paddingRight: "4px",
                paddingTop: "8px",
                paddingBottom: "8px",
                scrollbarWidth: "thin",
                scrollbarColor:
                  isdark === "light"
                    ? `${iscolour?.Colour8} ${iscolour?.Colour5}`
                    : `${iscolourDark?.Colour7} ${iscolourDark?.Colour9}`,
              }}
            >
              {filteredData.map((item, index) => {
                const safeSelectedId = selectedId || [];
                const safeSelectedValue = selectedValue || [];

                const isSelected = isMulti
                  ? (selectedId || []).includes(item.value)
                  : selectedId === item.value;

                return (
                  <div key={index}>
                    <div
                      onClick={() => {
                        if (isMulti) {
                          const isAlready = safeSelectedId.includes(item.value);

                          let newIds;
                          let newValues;

                          if (isAlready) {
                            const indexToRemove = safeSelectedId.indexOf(item.value);
                            newIds = [...safeSelectedId];
                            newValues = [...safeSelectedValue];
                            if (indexToRemove !== -1) {
                              newIds.splice(indexToRemove, 1);
                              newValues.splice(indexToRemove, 1);
                            }
                          } else {
                            newIds = [...safeSelectedId, item.value];
                            newValues = [...safeSelectedValue, item.label];
                          }

                          setSelectedId(newIds);
                          setSelectedValue(newValues);
                        } else {
                          setSelectedId(item.value);
                          setSelectedValue(item.label);
                          setOpen(false);


                          // ✅ Parent component ko selected item bhejo
                          if (onChange) {
                            onChange(item);
                          }
                        }
                      }}
                      style={{
                        padding: "10px 14px",
                        borderRadius: "12px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "14px",
                        cursor: "pointer",
                        transition: "0.25s",

                        background: isSelected
                          ? isdark === "light"
                            ? iscolour?.Colour6
                            : iscolourDark?.Colour9
                          : "transparent",

                        color: isSelected
                          ? isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour4
                          : isdark === "light"
                            ? "#000"
                            : iscolourDark?.Colour1,
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected)
                          e.currentTarget.style.background =
                            isdark === "light"
                              ? iscolour?.Colour4
                              : iscolourDark?.Colour7;
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected)
                          e.currentTarget.style.background = "transparent";
                      }}
                    >
                      {item.label}
                    </div>

                    {/* Divider */}
                    <div
                      style={{
                        height: "1px",
                        width: "100%",
                        background:
                          isdark === "light"
                            ? iscolour?.Colour4
                            : iscolourDark?.Colour5,
                        margin: "4px 0",
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MillstageDropDownFilter;
